import { InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export default function Input({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
    return (
        <input
            className={cn(
                "w-full rounded-xl border border-rose-100 bg-white px-3 py-2 text-sm outline-none ring-0 transition focus:border-brand-300",
                className
            )}
            {...props}
        />
    );
}